import { Box, Paper, Stack, Typography, Divider } from "@mui/material"
import DiseaseItem from "./DiseaseItem"
import useAppStore from "store/app"
import DiseaseDescription from "./DiseaseDescription"
import { formatDate } from "config/helpers"
import BottomDrawer from "../BottomDrawer"
import useTranslation from "../../../hooks/use_translation"

const DiseaseList = ({ created_at, data }) => {
  const { activeDisease } = useAppStore((state) => state.anamnesis)
  const { anamnesis } = useTranslation()
  return (
    <Paper elevation={0} sx={{ mt: 3, p: 2, borderRadius: "10px", backgroundColor: "white" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 2,
        }}
      >
        <Box>
          <Typography variant="h6" fontWeight={700}>
            {anamnesis?.result_card_title}
          </Typography>
          <Typography component="p" variant="caption">
            {anamnesis?.result_card_subtitle}
          </Typography>
        </Box>

        <Typography variant="caption" sx={{ mt: 1 }}>
          {created_at && formatDate(created_at)}
        </Typography>
      </Box>

      <Stack>
        {data.length === 0 ? (
          <Typography>{anamnesis?.no_possible_diseases}</Typography>
        ) : (
          data.map((item, i) => (
            <Box key={i}>
              <DiseaseItem number={i} item={item} />
              {i < data.length - 1 && <Divider sx={{ my: 2 }} />}
            </Box>
          ))
        )}
      </Stack>

      <BottomDrawer>
        <DiseaseDescription disease={activeDisease?.disease} />
      </BottomDrawer>
    </Paper>
  )
}

export default DiseaseList
